import React, { createContext, useContext, ReactNode, useCallback } from 'react';
import { reportErrorToSentry } from 'src/utils/errorReporting';

interface ErrorContextType {
  reportError: (
    error: any,
    context?: {
      endpoint?: string;
      method?: string;
      operation?: string;
      component?: string;
      action?: string;
    }
  ) => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const reportError = useCallback(
    (
      error: any,
      context?: {
        endpoint?: string;
        method?: string;
        operation?: string;
        component?: string;
        action?: string;
      }
    ) => {
      reportErrorToSentry(error, context);
    },
    []
  );

  return <ErrorContext.Provider value={{ reportError }}>{children}</ErrorContext.Provider>;
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};
